import enUS from './en-US';
import nlNL from './nl-NL';

export default {
  'en-US': enUS,
  'nl-NL': nlNL,
};
